export default class HelperPessoa {
  static getPessoaNome (pessoa) {
    if (!pessoa) return '-'
    switch (pessoa.tipo) {
      case 'PF':
        return pessoa.pessoaFisica.nome
      case 'PJ':
        return pessoa.pessoaJuridica.razaoSocial
      default: return '-'
    }
  }
  static getPessoaCpfCnpj (pessoa) {
    if (pessoa.pessoaFisica !== null) {
      return pessoa.pessoaFisica.cpf
    } else if (pessoa.pessoaJuridica !== null) {
      return pessoa.pessoaJuridica.cnpj
    }
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/utils/helperPessoa.js